import { DependenciesInjection } from "app/di/DependencyInjection";
import { SupplierManagementImpl } from "../data/SupplierManagementImpl";
import { ISupplierManagementRepository } from "../domain/repositories/ISupplierManagementRepository";
import { SupplierManagementUseCase } from "../domain/useCases/SupplierManagementUseCase";
import { SupplierManagementViewModel } from "../presentation/viewModel/SupplierManagementViewModel";
import { SupplierManagementToken } from "./SupplierManagementToken";

export class SupplierManagementInjection {
  static initInjections() {
    DependenciesInjection.register<ISupplierManagementRepository>(
      SupplierManagementToken.ISupplierManagementRepository,
      SupplierManagementImpl,
      "otherRepo",
    );
    DependenciesInjection.register<SupplierManagementUseCase>(
      SupplierManagementToken.SupplierManagementUseCase,
      SupplierManagementUseCase,
      "otherRepo",
    );
    DependenciesInjection.register<SupplierManagementViewModel>(
      SupplierManagementToken.SupplierManagementViewModel,
      SupplierManagementViewModel,
      "viewModel",
    );
  }

  static getRepo() {
    return DependenciesInjection.getRepo<ISupplierManagementRepository>(
      SupplierManagementToken.ISupplierManagementRepository,
    );
  }

  static getUseCase() {
    return DependenciesInjection.getRepo<SupplierManagementUseCase>(
      SupplierManagementToken.SupplierManagementUseCase,
    );
  }
}
